import { render } from "./BlogSection.vue?vue&type=template&id=c3c6bab4"
import script from "./BlogSection.vue?vue&type=script&lang=js"
export * from "./BlogSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__